export default function StocksConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('stocks');
}

StocksConfiguration.$inject = ['$translatePartialLoaderProvider'];
